import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from './language.service';

@Pipe({
  name: 'langService'
})
export class LangServicePipe implements PipeTransform {
  constructor(private langServ: LanguageService) {}

  // Cache translations per input value to avoid re-creating Promises on each change detection
  private cache: Map<string, Promise<string>> = new Map();
  private callCount = 0;

  transform(value: string, params?: Record<string, string | number | null | undefined>): Promise<string> {
    this.callCount++;
    if (this.callCount % 50 === 0) {
      console.debug(`LangServicePipe called ${this.callCount} times, current value:`, value);
    }

    if (!value && value !== '') {
      return Promise.resolve(value);
    }

    const paramKey = params ? `::${JSON.stringify(params)}` : '';
    const cacheKey = `${value}${paramKey}`;

    // If we already requested a translation for this exact value, return the same Promise
    const cached = this.cache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const p = this.langServ.translate(value)
      .then(res => {
        if (!params) {
          return res;
        }
        // Use the interpolate method from LanguageService for placeholder replacement
        return this.langServ.interpolate(res, params);
      })
      .catch(err => {
        console.warn('LangServicePipe translation error for value:', value, err);
        return value;
      });

    this.cache.set(cacheKey, p);
    return p;
  }
}

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
}